export default __webpack_public_path__ + "static/media/Mark-2-Suit-Cycles-10.3d15d4cf.jpg";